import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWheelLoader = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 590,
	height: 590,
	viewBox: "0 0 590 590",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 295,
			cy: 295,
			r: 293.985,
			fill: "#d3673b"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5b2e3b",
			d: "m191.221 569.661 109.87-276.781L55.486 123.962C21.183 172.054 1 230.911 1 294.485v.05c0 125.833 79.067 233.182 190.221 275.126Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e1bf59",
			d: "M294.985 588.52c38.125 0 74.554-7.259 107.982-20.468L301.473 292.658l-.01-.011-39.074 97.209-6.251 15.536-6.336 15.78-29.077 72.333-9.541 23.708-8.956 22.296-7.089 17.638-4.752 12.197c32.5 12.378 67.753 19.176 104.598 19.176Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d3673b",
			d: "M294.985.5c-98.72 0-186.069 48.663-239.384 123.305l245.894 168.874 101.339 275.428C511.84 525.099 588.97 418.824 588.97 294.535v-.05C588.97 132.122 457.348.5 294.985.5Z"
		})
	]
});
export default SvgWheelLoader;
